/**
 * @file individualViewRoutes.js
 * @description Routes that only exist on the Individual side of the portal, including portal
 * page views (/portal-pages/{id}) and message views (/my-messages/{notificationId}). Reaching any
 * of them puts a Client Admin back into Individual view, so the page they asked for is
 * never framed by the Client Admin menu.
 */
import { matchPath } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { isPortalPageViewPath } from './portalPageLinks';

const INDIVIDUAL_VIEW_ROUTES = [
    ROUTES.MY_ASSETS,
    ROUTES.MY_BENEFITS,
    ROUTES.MY_MESSAGES,
    ROUTES.MY_HOME,
];

function isIndividualViewRoute(pathOrUrl) {
    if (typeof pathOrUrl !== 'string' || !pathOrUrl) {
        return false;
    }

    try {
        const { pathname } = new URL(pathOrUrl, window.location.origin);
        const normalizedPathname =
            pathname.length > 1 && pathname.endsWith('/')
                ? pathname.slice(0, -1)
                : pathname;

        return (
            INDIVIDUAL_VIEW_ROUTES.includes(normalizedPathname) ||
            isPortalPageViewPath(normalizedPathname) ||
            matchPath(ROUTES.MY_MESSAGES_VIEW, normalizedPathname) !== null
        );
    } catch (error) {
        return false;
    }
}

export { INDIVIDUAL_VIEW_ROUTES, isIndividualViewRoute };
